import { Injectable } from '@angular/core';
import { SelectOptionMobile } from '@shared/models/catalog.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CatalogItemsDataService {
  public selectColumns = new BehaviorSubject<SelectOptionMobile[] | null>(null);
  public pinChanged = new BehaviorSubject<boolean>(false);
  public isFirstColumnPinned = new BehaviorSubject<boolean>(true);
  public isAllSelected = new BehaviorSubject<boolean>(false);
}
